import { IUser } from "../../common/interfaces/iUser.interface";
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { userApi } from "../../services/user";
import { RootState } from '../store';

export type UserRole = 'mentor' | 'student' | 'none';

interface IUserState {
  info: IUser;
  accessToken: string;
  isAdmin: boolean;
  refreshToken: string;
  tenantID: string;
  isLoading: boolean;
  error: string;  
}

const initialState: IUserState = {
  info: {
    role: 'none',    
    email: '',
    fullName: '',
    firstName: '',
    avatar: '',
    id: '',
    lastName: '',
  },
  accessToken: '',
  isAdmin: false,
  refreshToken: '',
  tenantID: '',
  isLoading: false,
  error: '',
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<IUser>) => {
      state.info = action.payload;
    },
    setUserRole: (state, action: PayloadAction<UserRole>) => {
      state.info.role = action.payload;
    },
    setUserEmail: (state, action: PayloadAction<string>) => {
      state.info.email = action.payload;
    },
    logout: (state) => {
      state.info = initialState.info;
    },
    connectMessaging: () => {}    
  },
  extraReducers: (builder) => {
    //LOGIN RESPONSE DATA
    builder      
      .addMatcher(
        userApi.endpoints.login.matchFulfilled,
        (state, { payload }) => {
          // Перевіряємо структуру відповіді
          if (payload && typeof payload === 'object') {
            state.info = payload.user;
            state.accessToken = payload.accessToken || '';
            state.refreshToken = payload.refreshToken || '';
            state.tenantID = payload.tenantID || '';
            state.info.role =
              payload.user?.role === 'mentor' ? 'mentor' : 'student';
            state.isLoading = true;
            state.error = '';
          }
        }
      )
      .addMatcher(
        userApi.endpoints.login.matchPending,
        (state) => {
          state.isLoading = true;
          state.error = '';
        }
      )
      .addMatcher(
        userApi.endpoints.login.matchRejected,
        (state, { error }) => {
          state.isLoading = false;
          state.error = error.message || 'Login failed';
        }
      )      
  },
});

export const selectUser = (state: RootState) => state.user.info.role;
export const selectNotificationListener = (state: RootState) =>
  state.user.notificationListener;
export const selectProfile = (state: RootState) => state.user.info;
export const selectProfileID = (state: RootState) => state.user.info.profile_id;
export const selectDriverReceives = (state: RootState) =>
  state.user.driverReceives;

export const {
  setUser,
  setUserRole,
  logout,
  setUserEmail,
} = userSlice.actions;

export default userSlice.reducer;
